// src/pages/TransferRecord/index.js
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined,QuestionCircleOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography, Drawer, Tooltip } from "antd";
import TransferRecordFilters from "./components/TransferRecordFilters";
import TransferRecordTable from "./components/TransferRecordTable";
import { fetchTransferRecord } from "./TransferRecordThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const TransferRecord = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchTransferRecord({})); // initial load
  }, [dispatch]);

  const { filters } = useSelector((state) => state.transferRecord);

  const reportRef = useRef(null);
  const [helpOpen, setHelpOpen] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Transfer Record Report",
    removeAfterPrint: true,
  });

  const handleNavigateToBack = () => {
    navigate(-1);
  }

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToBack}
                style={{ marginRight: 8 }}
              />

              <Title
                level={4}
                style={{ margin: 0 }}
                className="reportBigTitle"
              >
                Transfer Receive Record
              </Title>

              <div style={{ marginLeft: "auto" }}>
                <Tooltip title="Help">
                  <Button
                    type="text"
                    icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                    onClick={() => setHelpOpen(true)}
                  />
                </Tooltip>
              </div>
            </div>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <TransferRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <TransferRecordTable />
        </Card>
      </App>
      <Drawer
        title="Transfer Receive Report Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Transfer Receive Report
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Transfer Receive Report module is used to monitor received
            inventory transfer transactions between branches or warehouse
            locations within the ERP system.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to View Transfer Receive Records</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Inventory → Transfer Receive Report</strong></li>
              <li>Select required filters and date range</li>
              <li>Review received transfer entries</li>
              <li>Verify branch and stock receive details</li>
              <li>Check received quantities and statuses</li>
              <li>Analyze completed transfer transactions</li>
              <li>Use Print option to generate report copy if needed</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Receive records indicate completed stock transfers.</li>
              <li>Filters can be used to narrow report results.</li>
              <li>Printed reports reflect current transfer receive data.</li>
              <li>Transfer receive tracking helps maintain inventory accuracy.</li>
            </ul>
          </div>
        </div>
      </Drawer>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Transfer Record Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <TransferRecordTable pagination={false} printMode={true} />}
        />
      </div>
    </div>
  );
};

export default TransferRecord;
